import React, {useEffect, useState} from "react";
import axios from "axios";
import NewSkillFinderDropdown from "./NewSkillFinderDropdown";
import NewSkillFinderSelectedSkills from "./NewSkillFinderSelectedSkills";
import {Config} from "../../../../../Config";
import LoadingIcon from "../../../../../Assets/Images/EclipseSpinner.svg";

const NewSkillFinder = (props) => {
    const [CurrentSearch, setCurrentSearch] = useState('')
    const [IsInsufficientChars, setIsInsufficientChars] = useState(false)
    const [ResIsOpen, setResIsOpen] = useState(false)
    const [SearchResults, setSearchResults] = useState([])
    const [IsLoading, setIsLoading] = useState(false)
    const [ShowModalInfo, setShowModalInfo] = useState(false)

    const handleSearchChange = (value) => {
        setCurrentSearch(value)
    }

    const handleRemoveSearch = () => {
        setCurrentSearch('')
    }

    const handleSearch = (skillTitleLike) => {
        let Req = {
            method: 'POST',
            baseURL: window._env_.API_URL + Config.PositionServiceURL + '/api/position-skill-recommendation',
            headers: {
                Authorization: `Bearer ${window.localStorage.getItem('Token')}`,
                "Content-Type": "application/json",
            },
            data: {
                criteria: {
                    skillTitleLike,
                }
            }
        }
        axios(Req)
            .then(Res => {
                setSearchResults(Res.data.results)
            })
            .finally(() => {
                setIsLoading(false)
            })
    }

    const toggleModalInfo = () => {
        setShowModalInfo(prev => !prev)
    }

    useEffect(() => {
        let DebounceId;

        if (CurrentSearch.length === 0) {
            setResIsOpen(false)
        } else if (CurrentSearch.length > 0 && CurrentSearch.length < 2) {
            setIsInsufficientChars(true)
            setResIsOpen(true)
        } else {
            setIsLoading(true)
            setIsInsufficientChars(false)
            DebounceId = setTimeout(() => handleSearch(CurrentSearch), 500)
        }

        return () => clearTimeout(DebounceId)
    }, [CurrentSearch])

    return (
        <div className='skill-finder-wrapper'>
            <section className='search-input'>
                <i className='feather-search'/>
                <input
                    value={CurrentSearch}
                    placeholder={props.Placeholder}
                    onChange={(e) => handleSearchChange(e.target.value)}
                    id='skill-finder-input'
                    type='text'
                    className='skill-search-input'
                    autoComplete='off'
                />
                {!!CurrentSearch ?
                    <i className='feather-x-circle' onClick={() => handleRemoveSearch()}/> :
                    null}

                <i className="feather-info" onClick={() => toggleModalInfo()} />
            </section>

            {ResIsOpen && IsInsufficientChars ?
                <div className="results-wrapper empty-res">
                    {props.MinCharsText}
                </div> :
                null}

            {ResIsOpen && !IsInsufficientChars ?
                IsLoading ?
                    <div className="results-wrapper loading-res">
                        <img src={LoadingIcon} alt='ic-load'/>
                    </div> :

                    SearchResults.length > 0 ?
                        <NewSkillFinderDropdown
                            translateText={(Label) => props.translateText(Label) }
                            SearchResults={SearchResults}
                            SelectedSkillIds={props.SelectedSkills.map(Skill => Skill.id)}
                            OnSelectSkill={(Skill) => props.OnSelectSkill(Skill)}
                        /> :

                        <div className="results-wrapper empty-res">
                            {props.NoResultText}
                        </div> :
                null}

            {props.SelectedSkills.length ?
                <NewSkillFinderSelectedSkills
                    translateText={(Label) => props.translateText(Label)}
                    SelectedSkills={props.SelectedSkills}
                    OnRemoveSkill={(Skill) => props.OnRemoveSKill(Skill)}
                /> :
                null}

            {ShowModalInfo ?
                <div className='overlay' onClick={() => toggleModalInfo()}>
                    <div className='modal-body'>
                        <div className='skill-modal-title'>
                            <span>{props.translateText('skill_finder_modal_info_title')}</span>
                            <i className='feather-x'></i>
                        </div>

                        <div className='skill-modal-description'>
                            {props.translateText('skill_finder_modal_info_1')}
                            <div className='space'></div>
                            {props.translateText('skill_finder_modal_info_2')}
                            <div className='space'></div>
                            {props.translateText('skill_finder_modal_info_3')}
                            <div className='space'></div>
                            {props.translateText('skill_finder_modal_info_4')}
                            <div className='space'></div>
                            {props.translateText('skill_finder_modal_info_pro_tip')}
                        </div>
                    </div>
                </div> :
                null}
        </div>
    );
};

export default NewSkillFinder;
